import styled, { css } from 'styled-components'

import { Colors } from '@fourthwall/components'

import { CommonButton, commonIndicatorStyles } from '../Navigation/Navigation.styled'

export const Container = styled.div<{ initiallyCollapsed: boolean }>`
  overflow: hidden;
  transition: height 0.3s;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ initiallyCollapsed }) =>
    initiallyCollapsed &&
    css`
      height: 0;
    `}
`

export const ArrowIcon = styled.div`
  position: absolute;
  display: none;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
`

export const GuideButton = styled(CommonButton)<{ active: boolean; withIndicator: boolean }>`
  color: ${Colors.GS600};
  position: relative;

  &::before {
    ${commonIndicatorStyles};
    display: none;
    height: calc(100% + 4px);
    left: 16px;
    top: 0;
  }

  &:hover {
    color: ${Colors.GS1000};

    ${ArrowIcon} {
      display: block;
      opacity: 0.5;
    }
  }

  ${({ withIndicator }) =>
    withIndicator &&
    css`
      &::before {
        display: block;
      }
    `}

  ${({ active }) =>
    active &&
    css`
      background: ${Colors.GS0};
      color: ${Colors.GS1000};
      font-weight: 600;

      &::before {
        height: calc(50% - 2px);
      }

      ${ArrowIcon} {
        display: block;
      }

      &:hover {
        ${ArrowIcon} {
          opacity: 1;
        }
      }
    `}
`
